import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
var CODE_LENGTH = 6;
var isNumber = function (x) { return x >= '0' && x <= '9'; };
var formComponentClass = 'form-control';
export function InputOTP(props) {
    var _a = props.label, label = _a === void 0 ? '' : _a, _b = props.id, id = _b === void 0 ? 'otp' : _b, _c = props.invalid, invalid = _c === void 0 ? false : _c, value = props.value, _d = props.disabled, disabled = _d === void 0 ? false : _d, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, autoFocus = props.autoFocus;
    var componentClass = 'otp';
    var inputRef = React.useRef(null);
    var empty = !value;
    var values = (value === null || value === void 0 ? void 0 : value.split('')) || [];
    var _e = React.useState(false), focused = _e[0], setFocused = _e[1];
    var onClick = function () {
        if (inputRef.current !== null) {
            inputRef.current.focus();
        }
    };
    var onKeyDownAccesible = function (e) {
        if (e.keyCode === 13) {
            onClick();
        }
    };
    var handleFocus = function (e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    };
    var handleBlur = function (e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    var handleChange = function (e) {
        var inputValue = e.target.value;
        if (!(inputValue === null || inputValue === void 0 ? void 0 : inputValue.split('').every(isNumber)))
            return null;
        if ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) > CODE_LENGTH)
            return null;
        var newValue = (value + inputValue).slice(0, CODE_LENGTH);
        if (newValue !== value) {
            onChange(newValue);
        }
        return undefined;
    };
    var onKeyDown = function (e) {
        if (e.keyCode === 8) {
            var newValue = value.slice(0, value.length - 1);
            onChange(newValue);
        }
    };
    return (React.createElement("div", { className: componentClass },
        label && (React.createElement("div", { className: "text--sm mb-3" },
            React.createElement("label", { className: bcx(formComponentClass, 'input-label', { empty: empty, disabled: disabled, focused: focused }), htmlFor: id }, label))),
        React.createElement("div", { className: bcx(componentClass, 'wrapper'), onClick: onClick, onKeyDown: onKeyDownAccesible, role: "button", tabIndex: -1 },
            React.createElement("input", { value: "", ref: inputRef, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, className: bcx(componentClass, 'input'), onKeyDown: onKeyDown, id: id, disabled: disabled, autoComplete: "off", autoFocus: autoFocus }),
            new Array(CODE_LENGTH).fill(0).map(function (_, i) { return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: bcx(componentClass, 'box', {
                        focused: focused,
                        invalid: invalid,
                        empty: empty,
                        disabled: disabled,
                    }) }, values[i] || React.createElement("span", { className: bcx(componentClass, 'placeholder-text') }, "0")),
                i === 2 && (React.createElement("div", { className: cx('text--no-select', bcx(componentClass, 'divider', { empty: empty, disabled: disabled })) }, "-")))); }))));
}
//# sourceMappingURL=InputOTP.js.map